import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({children}) => {
    const accessToken = useSelector(state => state.session.accessToken)
    return accessToken ? (children) : ( <Navigate to={'/'} />)
}

export default ProtectedRoute